import React, { useState } from "react";

const MOQPriceAdjuster = ({ minPrice, maxPrice, MOQ }) => {
  const [quantity, setQuantity] = useState(MOQ);
  
  // Calculate price per unit based on quantity
  // Price decreases proportionally above MOQ but not below minPrice
  const calculatePrice = (qty) => {
    if (qty <= MOQ) return maxPrice;
    // Linear price decrease formula:
    const priceDrop = ((maxPrice - minPrice) * (qty - MOQ)) / MOQ;
    const price = maxPrice - priceDrop;
    return price < minPrice ? minPrice : price;
  };
  
  const pricePerUnit = calculatePrice(quantity);
  const totalPrice = (pricePerUnit * quantity).toFixed(2);

  return (
    <div style={{ maxWidth: 400, margin: "auto", fontFamily: "Arial, sans-serif", padding: 20, border: "1px solid #ddd", borderRadius: 6 }}>
      <h3>MOQ Price Adjustment</h3>
      <div style={{ marginBottom: 12 }}>
        <label htmlFor="qty">Enter Quantity (KG): </label>
        <input
          id="qty"
          type="number"
          min={1}
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          style={{ width: 80, padding: 4, fontSize: 16 }}
        />
      </div>
      <div>
        <p>MOQ: <strong>{MOQ} KG</strong></p>
        <p>Price per KG: <strong>₹{pricePerUnit.toFixed(2)}</strong></p>
        <p>Total Price: <strong>₹{totalPrice}</strong></p>
      </div>
      {quantity < MOQ && (
        <p style={{ color: "red" }}>
          Note: Quantity below MOQ. Price may not apply or minimum order required.
        </p>
      )}
    </div>
  );
};

// Usage example with props:
// <MOQPriceAdjuster minPrice={700} maxPrice={1000} MOQ={10} />

export default MOQPriceAdjuster;
